import React from "react";
import { Send, PenLine } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function GuidelinesCTA() {
  const navigate = useNavigate();

  return (
    <section className="max-w-7xl mx-auto px-6 sm:px-10 pb-10 pt-8">
      <div className="bg-[#F4F1FC] rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4 text-center sm:text-left">
          <span className="w-12 h-12 rounded-full bg-purple-100 text-[#7209B7] flex items-center justify-center shrink-0">
            <Send className="w-5 h-5" />
          </span>
          <div>
            <h3 className="font-bold text-slate-900 text-base">
              Ready to Share Your Story?
            </h3>
            <p className="text-sm text-slate-500">
              Your journey could inspire someone's next adventure
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => navigate("/dashboard/create-blog")}
          className="inline-flex items-center gap-2 bg-[#7209B7] text-white font-semibold text-sm px-6 py-3 rounded-full hover:bg-[#5a07a0] active:scale-95 transition-all duration-200 shrink-0"
        >
          <PenLine className="w-4 h-4" />
          Start Writing
        </button>
      </div>
    </section>
  );
}
